import { px, rect, cRect, mRect, mPx, CENTER } from '../../../pixel/canvas';
import { SLOT } from '../slots';
import type { Hull } from '../../types';

export const hull_crab: Hull = {
  id: 'hull_crab',
  name: 'Crab',
  drawBody: (ctx, p) => {
    const cy = 35;
    const drawOval = (rx, ry, color) => {
      for (let y = -ry; y <= ry; y++) for (let x = -rx; x < rx; x++) {
        const fx = x + 0.5;
        if ((fx*fx)/(rx*rx) + (y*y)/(ry*ry) <= 1) px(ctx, CENTER + x, cy + y, color);
      }
    };
    drawOval(11, 5, p.primary);
    mRect(ctx, 8, 30, 2, 4, p.primary); mRect(ctx, 8, 28, 2, 2, p.shadow);
    mPx(ctx, 9, 27, p.metalDark); mPx(ctx, 9, 28, p.metal);
    for (let y = 1; y <= 5; y++) for (let x = -11; x < 11; x++) {
      const fx = x + 0.5;
      const r = (fx*fx)/121 + (y*y)/25;
      if (r <= 1 && r > 0.6) px(ctx, CENTER + x, cy + y, p.shadow);
    }
    cRect(ctx, 39, 16, 1, p.dark); cRect(ctx, 31, 6, 1, p.light); cRect(ctx, 34, 4, 2, p.accent);
  },
  mounts: {
    [SLOT.COCKPIT]:    { anchor: { x: 32, y: 33 }, cap: (ctx, p) => cRect(ctx, 35, 6, 1, p.dark) },
    [SLOT.WING_L]:     { anchor: { x: 21, y: 36 }, cap: (ctx, p) => { rect(ctx, 21, 35, 3, 3, p.shadow); px(ctx, 21, 35, p.dark); } },
    [SLOT.WING_R]:     { anchor: { x: 42, y: 36 }, cap: (ctx, p) => { rect(ctx, 40, 35, 3, 3, p.shadow); px(ctx, 42, 35, p.dark); } },
    [SLOT.ENGINE_L]:   { anchor: { x: 28, y: 41 }, cap: (ctx, p) => { rect(ctx, 27, 39, 3, 3, p.shadow); rect(ctx, 27, 39, 3, 1, p.dark); } },
    [SLOT.ENGINE_R]:   { anchor: { x: 36, y: 41 }, cap: (ctx, p) => { rect(ctx, 34, 39, 3, 3, p.shadow); rect(ctx, 34, 39, 3, 1, p.dark); } },
    [SLOT.WEAPON_TOP]: { anchor: { x: 32, y: 29 }, base: (ctx, p) => { cRect(ctx, 30, 4, 1, p.metal); cRect(ctx, 29, 2, 1, p.metalDark); } },
    [SLOT.NOSE]:       { anchor: { x: 32, y: 27 } },
  },
};
